import { all, call, put } from '@redux-saga/core/effects';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';

import { fetchReviewers as fetchReviewersAPI } from '@/features/common/api/fetchReviewers';
import { CommonDataKeys } from '@/store/commonData/CommonData.constants';
import { commonDataActions } from '@/store/commonData/CommonData.slice';

import { fetchPatientWorkQueue as fetchPatientWorkQueueAPI } from '../api/fetchPatientWorkQueue';
import { fetchPatientWorkQueueColumnSettings as fetchPatientWorkQueueColumnSettingsAPI } from '../api/fetchPatientWorkQueueColumnSettings';
import { patientWorkQueueActions } from '../PatientWorkQueue.slice';

type FetchQueuePayload = {
  isXsolisUser: boolean;
  showLoading?: boolean;
  teamId?: string;
};

export const $fetchPatientWorkQueue = createAction<FetchQueuePayload>(
  'sagas/fetchPatientWorkQueue'
);

export function* fetchPatientWorkQueue(
  action: PayloadAction<FetchQueuePayload>
): SagaIterator {
  const { isXsolisUser, showLoading = true, teamId } = action.payload;

  const {
    LOADING,
    REJECTED,
    SET_PAGINATION_TOTALS,
    SET_PATIENTS,
    SET_SETTINGS,
  } = patientWorkQueueActions;

  try {
    if (showLoading) yield put(LOADING(true));

    const [patientResult, columnsResult, reviewerResult] = yield all([
      call(fetchPatientWorkQueueAPI, { teamId }),
      call(fetchPatientWorkQueueColumnSettingsAPI, { teamId }),
      call(fetchReviewersAPI),
    ]);

    const { count: patientsCount, patients } = patientResult;

    yield put(
      SET_PATIENTS({
        isXsolisUser,
        patients,
      })
    );

    yield put(SET_PAGINATION_TOTALS({ count: patientsCount }));
    yield put(SET_SETTINGS(columnsResult.column_settings));

    yield put(
      commonDataActions.SET_COMMON_DATA_FIELD({
        data: reviewerResult.users,
        key: CommonDataKeys.REVIEWERS,
      })
    );

    if (showLoading) yield put(LOADING(false));
  } catch (error) {
    if (showLoading) yield put(LOADING(false));
    yield put(REJECTED(error));
  }
}
